import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const BED_NUMBER_GROUP_PATH = "/bed-number-group/v1";

export const getBedNumberGroupApi = async (params) =>
  await getRequest(BED_NUMBER_GROUP_PATH, params);

export const getBedNumberGroupByIdApi = async (id) =>
  await getRequest(`${BED_NUMBER_GROUP_PATH}/${id}`);

export const addBedNumberGroupApi = async (body) =>
  await postRequest(BED_NUMBER_GROUP_PATH, body);

export const updateBedNumberGroupApi = async (body) =>
  await putRequest(`${BED_NUMBER_GROUP_PATH}/${body?._id}`, body);

export const deleteBedNumberGroupByIdApi = async (id) =>
  await deleteRequest(`${BED_NUMBER_GROUP_PATH}/${id}`);
